module.exports = __webpack_public_path__ + "static/media/SI.a1ba1b48.png";